export default {
  props: {
    errors: Object
  },

  methods: {
    hasErrors(form = null) {
      let errors = form ? form.errors || {} : this.errors

      return !_.isEmpty(errors)
    },
    getErrors(field, form = null) {
      let errors = form ? form.errors || {} : this.errors

      if (field in errors) {
        return errors[field]
      }

      return ''
    }
  }
}
